var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserMenuArrow = function SvgUserMenuArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7D7D7D",
    fillOpacity: 0.8,
    d: "M11.294 15.706c.39.39 1.025.39 1.415 0l4-4a1 1 0 0 0 .216-1.09 1 1 0 0 0-.925-.62H8a1.004 1.004 0 0 0-.71 1.71l4 4z"
  })));
};
export default SvgUserMenuArrow;